export { default as InteractiveData } from './InteractiveData';
export { interactiveDataAdapter } from './adapters.ts';
